<div class="closeButton" >
    <button mat-icon-button [mat-dialog-close]="true">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div id="loginCard">
    <mat-card align="center"  class="loginMatCard">
        <h1 mat-dialog-title>{{'keyword_$232' | translate}} "{{data.board_name}}" </h1>
        <div mat-dialog-content>
           <p>{{'keyword_$233' | translate}}</p>
           <br>
           <br>
        </div>
        <div mat-dialog-actions align="center">
          <button mat-button class="requestButton" (click)="onNoClick()">{{'keyword_$228' | translate}}</button>
          <button mat-button class="requestButtonClose" cdkFocusInitial color="warn" (click)="submit(data.index)" >{{'keyword_$234' | translate}}</button>
        </div>
    </mat-card>
</div>
